export enum FilesPreview {
  Images = 'images',
  Documents = 'documents',
}
